import ClaimReviewOverviewPageActionTypes from './claim-review-overview-page-action-types';
import axios from 'axios';
import ValidationError from '../../../utils/validation-error';

export const loadClaimReviewOverviewPage = (claimId) => async(dispatch, getState, { api }) => {
  dispatch({ type: ClaimReviewOverviewPageActionTypes.LOAD_CLAIM_REVIEW_OVERVIEW_START });
  const state = getState().claimReviewOverviewPage;
  try {
    state.cancelToken?.cancel();
    state.cancelToken = axios.CancelToken.source();
    const claim = await api.get(`api/general_competency_claims/${claimId}`, {}, state.cancelToken.token);
    let pdfObjectUrl = null;
    if (claim && claim.attachmentFilename) {
      try {
        const blob = await api.get(`api/general_competency_claims/${claimId}/attachment`, {}, state.cancelToken.token, 'blob');
        if (blob) {
          pdfObjectUrl = URL.createObjectURL(new File([blob], `claim-${claimId}.pdf`, { type: 'application/pdf' }));
        }
      } catch {
        // attachment may not exist
      }
    }
    dispatch({
      type: ClaimReviewOverviewPageActionTypes.LOAD_CLAIM_REVIEW_OVERVIEW_END,
      payload: {
        claim: claim ? {
          ...claim,
          occurredAt: claim.occurredAt ? new Date(claim.occurredAt.substring(0, 10) + 'T12:00:00') : null,
          createdOn: claim.createdOn ? new Date(claim.createdOn) : null,
          reviewedAt: claim.reviewedAt ? new Date(claim.reviewedAt) : null
        } : null,
        pdfObjectUrl
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: ClaimReviewOverviewPageActionTypes.LOAD_CLAIM_REVIEW_OVERVIEW_END });
      throw error;
    }
  }
};

export const approveClaim = () => async(dispatch, getState, { api }) => {
  const state = getState().claimReviewOverviewPage;
  const claimId = state.claim?.id;
  dispatch({ type: ClaimReviewOverviewPageActionTypes.LOAD_CLAIM_REVIEW_OVERVIEW_START });
  try {
    await api.put(`api/general_competency_claims/${claimId}/approve`);
    dispatch(loadClaimReviewOverviewPage(claimId));
  } catch (error) {
    dispatch({ type: ClaimReviewOverviewPageActionTypes.LOAD_CLAIM_REVIEW_OVERVIEW_END });
    throw error;
  }
};

export const openRejectDialog = () => (dispatch) => {
  dispatch({ type: ClaimReviewOverviewPageActionTypes.TOGGLE_REJECT_DIALOG, payload: { visible: true } });
};

export const closeRejectDialog = () => (dispatch) => {
  dispatch({ type: ClaimReviewOverviewPageActionTypes.TOGGLE_REJECT_DIALOG, payload: { visible: false } });
};

export const rejectClaim = (reviewComment) => async(dispatch, getState, { api }) => {
  const state = getState().claimReviewOverviewPage;
  const claimId = state.claim?.id;
  dispatch({ type: ClaimReviewOverviewPageActionTypes.LOAD_CLAIM_REVIEW_OVERVIEW_START });
  try {
    await api.put(`api/general_competency_claims/${claimId}/reject`, { reviewComment });
    dispatch(closeRejectDialog());
    dispatch(loadClaimReviewOverviewPage(claimId));
  } catch (error) {
    let rejectValidationResult = null;
    if (error instanceof ValidationError) {
      rejectValidationResult = {
        errorMessage: error.message,
        errors: error.errors
      };
    }
    dispatch({
      type: ClaimReviewOverviewPageActionTypes.LOAD_CLAIM_REVIEW_OVERVIEW_END,
      payload: { rejectValidationResult }
    });
    if (!rejectValidationResult) {
      throw error;
    }
  }
};

export const cleanupClaimReviewOverviewPage = () => async(dispatch, getState) => {
  const state = getState().claimReviewOverviewPage;
  if (state.pdfObjectUrl) {
    URL.revokeObjectURL(state.pdfObjectUrl);
  }
  dispatch({ type: ClaimReviewOverviewPageActionTypes.CLEANUP_CLAIM_REVIEW_OVERVIEW });
};
